/**
 * Altura total (px) del bloque de **dos filas** de la cabecera temporal del Gantt (alineado con cabecera
 * de tabla en Figma, ~49px). Cada fila ocupa la mitad (`1fr` / `1fr`).
 */
export const GHANTT_TIMELINE_HEADER_STACK_HEIGHT_PX = 49;
